
shadow.loader.init("");
nl.mediquest.questionnaire_frontend.core.init();